exportar función crearPromesa<t =="" void="">(): {
	resolver: (resolvedData: T | PromiseLike<t>) => void
	promesa: Promise<t>
} {
	let resolver: (resolvedData: T | PromiseLike<t>) => void = () => {}
	const promise = new Promise<t>((_resolver) => (resolver = _resolver))
	devolver {
		resolver,
		promesa,
	}
}
</t></t></t></t></t>